/**
 * Blog Grid — AJAX category filter + numbered pagination.
 *
 * Each `[data-blog-grid]` section ships with its own REST endpoint URL,
 * per_page and columns config on data attributes (see blog-grid.php). On
 * filter or pagination click we fetch the endpoint, swap the cards and
 * pagination containers, and push the new state into the URL via History API.
 *
 * Graceful degradation: every pagination link is also a real `<a href>` to the
 * server-rendered URL, so without JS the page just reloads.
 */
(function () {
    function initBlogGrid(context) {
        var root  = context || document;
        var grids = root.querySelectorAll('[data-blog-grid]');
        grids.forEach(bindGrid);
    }

    function bindGrid(grid) {
        if (grid.dataset.blogGridBound === '1') return; // idempotent
        grid.dataset.blogGridBound = '1';

        var state = {
            cat:  grid.dataset.currentCat || '',
            page: parseInt(grid.dataset.currentPage, 10) || 1
        };

        // Filter clicks → reset to page 1 of the chosen category.
        grid.addEventListener('click', function (e) {
            var filterBtn = e.target.closest('.blog-grid__filter-btn');
            if (filterBtn && grid.contains(filterBtn)) {
                e.preventDefault();
                var next = filterBtn.getAttribute('data-filter') || 'all';
                if (next === 'all') next = '';
                setActiveFilter(grid, filterBtn);
                state.cat  = next;
                state.page = 1;
                fetchAndSwap(grid, state, true);
                return;
            }

            var pageLink = e.target.closest('.blog-grid__page-link');
            if (pageLink && grid.contains(pageLink)) {
                e.preventDefault();
                var page = parseInt(pageLink.getAttribute('data-page'), 10);
                if (!page || page === state.page) return;
                state.page = page;
                fetchAndSwap(grid, state, true);
            }
        });

        // Browser back/forward — re-read URL and refetch.
        window.addEventListener('popstate', function () {
            var params = new URLSearchParams(window.location.search);
            state.cat  = params.get('cat') || '';
            state.page = parseInt(params.get('page'), 10) || 1;
            syncFilterUI(grid, state.cat);
            fetchAndSwap(grid, state, false);
        });
    }

    function setActiveFilter(grid, btn) {
        grid.querySelectorAll('.blog-grid__filter-btn').forEach(function (b) {
            b.classList.remove('active');
        });
        btn.classList.add('active');
    }

    function syncFilterUI(grid, slug) {
        var target = slug || 'all';
        grid.querySelectorAll('.blog-grid__filter-btn').forEach(function (b) {
            b.classList.toggle('active', b.getAttribute('data-filter') === target);
        });
    }

    function fetchAndSwap(grid, state, pushHistory) {
        var url = new URL(grid.dataset.restUrl, window.location.origin);
        if (state.cat) url.searchParams.set('cat', state.cat);
        url.searchParams.set('page', state.page);
        url.searchParams.set('per_page', grid.dataset.perPage || '12');
        url.searchParams.set('columns', grid.dataset.columns || '3');

        grid.classList.add('blog-grid--loading');

        fetch(url.toString(), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(function (res) {
                if (!res.ok) throw new Error('HTTP ' + res.status);
                return res.json();
            })
            .then(function (data) {
                var cardsEl = grid.querySelector('.blog-grid__cards');
                var pageWrap = grid.querySelector('.blog-grid__pagination-wrap');
                if (cardsEl)  cardsEl.innerHTML  = data.html || '';
                if (pageWrap) pageWrap.innerHTML = data.pagination || '';

                grid.dataset.currentCat  = state.cat;
                grid.dataset.currentPage = String(state.page);

                if (pushHistory) {
                    var pageUrl = new URL(window.location.href);
                    if (state.cat) pageUrl.searchParams.set('cat', state.cat); else pageUrl.searchParams.delete('cat');
                    if (state.page > 1) pageUrl.searchParams.set('page', state.page); else pageUrl.searchParams.delete('page');
                    window.history.pushState({}, '', pageUrl.toString());
                }

                // Scroll the grid into view at the top of the viewport so paging
                // doesn't strand the user mid-content.
                grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
            })
            .catch(function (err) {
                console.error('Blog grid fetch failed:', err);
            })
            .finally(function () {
                grid.classList.remove('blog-grid--loading');
            });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initBlogGrid(); });
    } else {
        initBlogGrid();
    }

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=blog-grid', function ($block) {
            if ($block && $block[0]) initBlogGrid($block[0]);
        });
    }
})();
